"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1099],{

/***/ 50331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ CopyButton; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18060);
/* harmony import */ var _mantine_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3241);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  timeout: 1e3
};
function CopyButton(props) {
  const _a = (0,_mantine_styles__WEBPACK_IMPORTED_MODULE_1__/* .useComponentDefaultProps */ .N4)("CopyButton", defaultProps, props), { children, timeout, value } = _a, others = __objRest(_a, ["children", "timeout", "value"]);
  const clipboard = (0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useClipboard */ .V)({ timeout });
  const copy = () => clipboard.copy(value);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children(__spreadValues({ copy, copied: clipboard.copied }, others)));
}
CopyButton.displayName = "@mantine/core/CopyButton";


//# sourceMappingURL=CopyButton.js.map


/***/ }),

/***/ 18060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useClipboard; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useClipboard({ timeout = 2e3 } = {}) {
  const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const [copied, setCopied] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [copyTimeout, setCopyTimeout] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const handleCopyResult = (value) => {
    clearTimeout(copyTimeout);
    setCopyTimeout(setTimeout(() => setCopied(false), timeout));
    setCopied(value);
  };
  const copy = (valueToCopy) => {
    if ("clipboard" in navigator) {
      navigator.clipboard.writeText(valueToCopy).then(() => handleCopyResult(true)).catch((err) => setError(err));
    } else {
      setError(new Error("useClipboard: navigator.clipboard is not supported"));
    }
  };
  const reset = () => {
    setCopied(false);
    setError(null);
    clearTimeout(copyTimeout);
  };
  return { copy, reset, error, copied };
}


//# sourceMappingURL=use-clipboard.js.map


/***/ }),

/***/ 90600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58036);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50331);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67841);
/* harmony import */ var _form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85119);





var ShareModal = function(param) {
    var opened = param.opened, setOpened = param.setOpened, link = param.link;
    var close = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setOpened(false);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Transition */ .u, {
        mounted: opened,
        transition: "slide-up",
        duration: 200,
        timingFunction: "ease",
        children: function(styles) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-white shadow-card rounded-lg p-4 text-gray_58 relative z-[21]",
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, styles),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__/* .CloseIcon */ .Tw, {
                            className: "fill-primary action",
                            onClick: close
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-bodyS font-bold",
                        children: "Share via link"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-center mt-4 mb-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                value: link,
                                className: "w-full flex-1 outline-none p-1 h-[30px] bg-gray_f9 text-body text-ellipsis overflow-hidden whitespace-nowrap"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex ml-3 flex-shrink-0",
                                "data-track": "copy_link",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_5__/* .CopyButton */ .q, {
                                    value: link || "",
                                    children: function(param) {
                                        var copied = param.copied, copy = param.copy;
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z, {
                                            variant: "filled",
                                            size: "xs",
                                            onClick: function() {
                                                copy();
                                                setTimeout(function() {
                                                    setOpened(false);
                                                }, 250);
                                            },
                                            children: [
                                                " ",
                                                copied ? "Copied \uD83C\uDF89" : "Copy Link"
                                            ]
                                        });
                                    }
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ShareModal);


/***/ }),

/***/ 45206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85119);
/* harmony import */ var _components_common_ShareLinkModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90600);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50331);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67841);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98786);
/* harmony import */ var _hooks_useClaimerContract__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48728);
/* harmony import */ var _hooks_useRequest__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21706);
/* harmony import */ var _chain_info_ZetaChain__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98982);












var ROLE_DESC = [
    "Scientist",
    "Engineer",
    "Doctor",
    "Security",
    "Artist"
];
var ClaimerMintResult = function(param) {
    var nftMeta = param.nftMeta, chainId = param.chainId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), shareLinkOpened = ref[0], setShareLinkOpened = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), shareLink = ref1[0], setShareLink = ref1[1];
    var address = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().address;
    var claimerContract = (0,_hooks_useClaimerContract__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(chainId);
    var role = nftMeta ? nftMeta.role : claimerContract.role;
    var ref2 = (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(address ? {
        function: "network/getValidatorOfClaimer",
        data: {
            address: address,
            role: role
        },
        header: {
            endpoint: "network"
        }
    } : null), validatorInfo = ref2.data;
    var validatorId = nftMeta ? nftMeta.validator : validatorInfo === null || validatorInfo === void 0 ? void 0 : validatorInfo.validatorTokenId;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!address || typeof validatorId === "undefined") {
            return setShareLink("");
        }
        setShareLink("".concat(window.location.origin, "/mint/claimer?lieutenantAddress=").concat(address, "&validatorId=").concat(validatorId));
    }, [
        address,
        validatorId
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "max-w-[629px] mx-auto pb-[115px] px-5 sm:px-0 mt-10 sm:mt-[83px] animate__animated animate__fadeInUp",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-[#EBF3FF] rounded-2xl p-4 sm:p-20 flex flex-col items-center",
                style: {
                    boxShadow: "2px 4px 16px rgba(0, 0, 0, 0.05)"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "w-full",
                        src: "/assets/mint/demo-id-card.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-[28px] font-bold text-dark1 text-center max-w-[409px]",
                        children: [
                            "Congrats, you received the role of a ",
                            ROLE_DESC[role],
                            "!"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-2 text-dark1 text-center max-w-[409px] leading-snug",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Your role was selected based on your KARAT score"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__/* .QuestionIcon */ .UO, {
                                        className: "inline w-3 h-3 fill-primary ml-1 mt-[2px] action"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    " ",
                                    "In addition to this NFT, you’ll also receive KARAT tokens in the near future. Stay tuned for the token airdrop"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center mt-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative",
                    children: [
                        shareLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_9__/* .CopyButton */ .q, {
                            value: shareLink,
                            children: function(param) {
                                var copied = param.copied, copy = param.copy;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center justify-center font-medium action text-primary text-sm",
                                    onClick: copy,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__/* .Add1Icon */ .PZ, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "ml-2",
                                            children: copied ? "Copied \uD83C\uDF89" : "Copy referral link"
                                        })
                                    ]
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                            classNames: {
                                inner: "text-body ",
                                root: "w-[255px] mt-4"
                            },
                            size: "md",
                            radius: "xl",
                            onClick: function() {
                                if (chainId === _chain_info_ZetaChain__WEBPACK_IMPORTED_MODULE_8__/* .ZetaChain_Test.chainId */ .O.chainId) {
                                    next_router__WEBPACK_IMPORTED_MODULE_4___default().push("/dashboard/network");
                                } else {
                                    window.open("https://www.okx.com/web3?wallet=".concat(address), "_blank");
                                }
                            },
                            children: "View your NFT"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute w-[250px] left-[-100px] sm:right-0 sm:left-[-50px] bottom-[54px]",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_ShareLinkModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                opened: shareLinkOpened,
                                setOpened: setShareLinkOpened,
                                link: shareLink
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClaimerMintResult);


/***/ }),

/***/ 56674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85119);
/* harmony import */ var _hooks_useVerifyClaim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37091);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31003);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33708);
/* harmony import */ var _mantine_hooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91759);
/* harmony import */ var _components_common_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58163);
/* harmony import */ var _hooks_useToggleStatus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45576);
/* harmony import */ var _hooks_useRequest__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21706);
/* harmony import */ var _utils_format__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6767);
/* harmony import */ var _hooks_useMintReferral__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65581);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55678);













var SelectValidatorStep = function(param) {
    var chainId = param.chainId;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_mantine_hooks__WEBPACK_IMPORTED_MODULE_11__/* .useDisclosure */ .q)(false), 2), selectorOpen = ref[0], ref1 = ref[1], openSelector = ref1.open, closeSelector = ref1.close;
    var ref2 = (0,_hooks_useVerifyClaim__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("validator"), result = ref2.result, changeVerifyState = ref2.changeVerifyState, changeForm = ref2.changeForm, form = ref2.form;
    var validatorId = (0,_hooks_useMintReferral__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(chainId).validatorId;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), disableSelect = ref3[0], setDisableSelect = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), query = ref4[0], setQuery = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setDisableSelect(!!validatorId && validatorId !== "1");
        if (validatorId) {
            changeForm(validatorId);
            setTimeout(function() {
                setQuery(String(validatorId));
            }, 100);
        }
    }, [
        validatorId
    ]);
    var ref5 = (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        function: "validator/getValidatorList",
        data: {
            query: query,
            version: "v1"
        },
        header: {
            endpoint: "network"
        }
    }, {
        onSuccess: function onSuccess(data) {
            if (validatorId && validatorId === form.validator) {
                var exist = data.find(function(item) {
                    return String(item.validatorTokenId) === String(validatorId);
                });
                if (!exist) {
                    setDisableSelect(false);
                    changeForm(undefined);
                    setQuery("");
                    react_toastify__WEBPACK_IMPORTED_MODULE_9__/* .toast.info */ .Am.info("Validator id ".concat(validatorId, " not valid, please select other"));
                }
            }
        }
    }), validatorList = ref5.data, isValidatorListLoading = ref5.isLoading;
    var validatorSelectList = [
        {
            label: "I don’t have a validator",
            value: "empty"
        }, 
    ].concat((validatorList || []).map(function(item) {
        var name = item.name;
        if (item.validatorTokenId === "1") {
            name = "OKX";
        }
        return {
            label: "#".concat(item.validatorTokenId, " ").concat(name || ""),
            value: String(item.validatorTokenId)
        };
    }));
    var ref6 = (0,_hooks_useRequest__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(form.validator && form.validator !== "empty" && selectorOpen ? {
        function: "validator/getValidator",
        data: {
            validatorTokenId: parseInt(form.validator),
            version: "v1"
        },
        header: {
            endpoint: "network"
        }
    } : null), validator = ref6.data;
    var ref7 = (0,_hooks_useToggleStatus__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("claimerMintToggleStatus"), claimerMintToggleStatus = ref7.claimerMintToggleStatus, toggle = ref7.toggle;
    var opened = claimerMintToggleStatus.validator;
    var toggleCard = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        toggle("validator");
    }, [
        toggle
    ]);
    var verifyed = result["validator"];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        changeVerifyState(typeof form.validator !== "undefined");
    }, [
        form.validator
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "claim-step-card  ".concat(opened ? "border-primary bg-[rgba(235,243,255,0.3)]" : ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex cursor-pointer",
                onClick: toggleCard,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_components_common_icons__WEBPACK_IMPORTED_MODULE_2__/* .CheckIcon */ .nQ, {
                        className: "w-5 h-5 ".concat(verifyed ? "fill-green" : "")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "font-semibold text-dark1 ml-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: "Select validator"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-gray1 font-normal text-sm mt-1 ".concat(opened ? "block" : "hidden"),
                                children: "Select or search for your validator"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex-1"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_icons__WEBPACK_IMPORTED_MODULE_4__/* .ArrowDownIcon */ .ve, {
                        className: "transition-all self-center ".concat(opened ? "rotate-180" : "")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_12__/* .Collapse */ .U, {
                in: opened,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-4 pl-7 cursor-auto",
                    onClick: function(e) {
                        e.stopPropagation();
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_13__/* .Select */ .Ph, {
                            placeholder: "Search by name or validator id",
                            data: validatorSelectList,
                            classNames: {
                                input: "rounded-lg border-[#E7E7E7] hover:border-primary",
                                dropdown: "custom-flip"
                            },
                            value: form.validator,
                            onFocus: openSelector,
                            onChange: function(value) {
                                console.log("value", value);
                                changeForm(value);
                            },
                            onSearchChange: function(q) {
                                if (q.indexOf("#") === 0) {
                                    setQuery(q.replace(/^#/, "").split(" ")[0]);
                                } else {
                                    setQuery(q);
                                }
                            },
                            filter: function() {
                                return true;
                            },
                            searchable: true,
                            disabled: disableSelect,
                            size: "md",
                            rightSection: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_icons__WEBPACK_IMPORTED_MODULE_4__/* .ArrowDownIcon */ .ve, {
                                className: "transition-all self-center ".concat(selectorOpen ? "rotate-180" : "")
                            })
                        }),
                        validator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-2 flex px-4 gap-8 flex-wrap sm:gap-[60px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-dark2 text-xs",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "font-semibold",
                                            children: "Address"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-1",
                                            children: (0,_utils_format__WEBPACK_IMPORTED_MODULE_7__/* .trimAddr1 */ .Cr)(validator.ownerAddress)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-dark2 text-xs",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "font-semibold",
                                            children: "Teammates"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-1",
                                            children: validator.referralNum
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectValidatorStep);


/***/ }),

/***/ 48728:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClaimerContract; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69077);
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98786);
/* harmony import */ var _services_contract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26720);





function useClaimerContract(chainId) {
    var ref, ref1, ref2;
    var address = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)().address;
    var contract = _services_contract__WEBPACK_IMPORTED_MODULE_1__/* .claimerContracts */ .rR[chainId];
    var data = (0,wagmi__WEBPACK_IMPORTED_MODULE_2__/* .useContractReads */ .Dm)({
        watch: false,
        scopeKey: "claimer-contract",
        contracts: [
            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, contract), {
                functionName: "tokenIdCounter"
            }),
            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, contract), {
                functionName: "balanceOf",
                args: [
                    address
                ]
            }),
            (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, contract), {
                functionName: "claimerRoles",
                args: [
                    address
                ]
            }), 
        ]
    }).data;
    var balance = (data === null || data === void 0 ? void 0 : (ref = data[1]) === null || ref === void 0 ? void 0 : ref.result) || 0n;
    return {
        quantity: Number((data === null || data === void 0 ? void 0 : (ref1 = data[0]) === null || ref1 === void 0 ? void 0 : ref1.result) || 0),
        isReady: !!data,
        balance: balance,
        minted: balance > 0n,
        role: Number(data === null || data === void 0 ? void 0 : (ref2 = data[2]) === null || ref2 === void 0 ? void 0 : ref2.result)
    };
}


/***/ }),

/***/ 55541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMintClaimer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(70655);
/* harmony import */ var _hooks_useBridge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useVerifyClaim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37091);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69077);
/* harmony import */ var wagmi_actions__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(17276);
/* harmony import */ var _services_network_claimer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21373);
/* harmony import */ var _hooks_useAccount__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98786);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27234);
/* harmony import */ var _chain_info_contracts_ClaimerNFT_json__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(319);
/* harmony import */ var _config_config__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35055);
/* harmony import */ var _hooks_useMintHistory__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56146);
/* harmony import */ var _hooks_useClaimerContract__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48728);
/* harmony import */ var _hooks_useMintResult__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(24455);
/* harmony import */ var _hooks_useMintReferral__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65581);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8891);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(mixpanel_browser__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _utils_validate__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68974);
/* harmony import */ var _services_payment__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(78338);
/* harmony import */ var viem__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(22852);
/* harmony import */ var _services_contract__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26720);
























function parseFormValidatorId(form) {
    var validatorId = !form.validator ? "13" : form.validator === "empty" ? "13" : form.validator;
    return validatorId;
}
function useMintClaimer() {
    var ref = (0,_hooks_useAccount__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), address = ref.address, isLogin = ref.isLogin, login = ref.login;
    var chain = (0,wagmi__WEBPACK_IMPORTED_MODULE_16__/* .useNetwork */ .LN)().chain;
    var ref1 = (0,_hooks_useBridge__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(), depositSuccess = ref1.depositSuccess, depositing = ref1.depositing, karatDeposit = ref1.karatDeposit, zkSyncDeposit = ref1.zkSyncDeposit;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), minting = ref2[0], setMinting = ref2[1];
    var switchNetworkAsync = (0,wagmi__WEBPACK_IMPORTED_MODULE_16__/* .useSwitchNetwork */ .g0)().switchNetworkAsync;
    var form = (0,_hooks_useVerifyClaim__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().form;
    var ref3 = (0,_hooks_useMintHistory__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(), mintHistory = ref3.history, mintStatus = ref3.status;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), mintId = ref4[0], setMintId = ref4[1];
    var ref5 = (0,_hooks_useMintReferral__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK), lieutenantAddress = ref5.lieutenantAddress, isValidLieutenant = ref5.isValidLieutenant, hasParamLieutenant = ref5.hasParamLieutenant;
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), nftMeta = ref6[0], setNftMeta = ref6[1];
    var claimerContractInfo = (0,_hooks_useClaimerContract__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK);
    var claimerContract = (0,_stores__WEBPACK_IMPORTED_MODULE_5__/* .useTypedSelector */ .ix)(function(state) {
        return state.devtool.config.claimerContract;
    });
    // const claimerContract = process.env
    //   .NEXT_PUBLIC_CLAIMER_RELAYER_CONTRACT as string;
    var mintResultRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)({
        timer: null,
        result: null,
        success: false,
        error: null
    });
    var ref7 = (0,_hooks_useMintResult__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(mintId), mintResult = ref7.data, isMintSuccess = ref7.isSuccess, mintError = ref7.error;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        mintResultRef.current.result = mintResult;
        mintResultRef.current.success = isMintSuccess;
        mintResultRef.current.error = mintError;
    }, [
        mintResult,
        isMintSuccess,
        mintError
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return function() {
            mintResultRef.current.timer && clearInterval(mintResultRef.current.timer);
        };
    }, []);
    var ref8 = (0,wagmi__WEBPACK_IMPORTED_MODULE_16__/* .useContractWrite */ .GG)({
        address: claimerContract,
        abi: _chain_info_contracts_ClaimerNFT_json__WEBPACK_IMPORTED_MODULE_6__/* .abi */ .Mt,
        functionName: "mintClaimerwithSig",
        chainId: _config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK
    }), mintClaimerByContract = ref8.writeAsync, mintData = ref8.data;
    var ref9 = (0,wagmi__WEBPACK_IMPORTED_MODULE_16__/* .useWaitForTransaction */ .BX)({
        hash: mintData === null || mintData === void 0 ? void 0 : mintData.hash,
        chainId: _config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK
    }), fetchTransaction = ref9.refetch;
    var contractMintWithPay = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(paymentType, amount) {
            var resp, e, validatorId, result, res, transReceipt, e1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setMinting(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            17,
                            18
                        ]);
                        if (!isLogin) {
                            login();
                            return [
                                2,
                                false
                            ];
                        }
                        if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== _config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK)) return [
                            3,
                            3
                        ];
                        // @ts-ignore
                        return [
                            4,
                            switchNetworkAsync(_config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        if (!(paymentType === _services_payment__WEBPACK_IMPORTED_MODULE_14__/* .ClaimerPaymentType.KAT */ .z.KAT)) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_19__/* .writeContract */ .n9)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, _services_contract__WEBPACK_IMPORTED_MODULE_15__/* .KATContractInfo */ .Fr), {
                                functionName: "approve",
                                args: [
                                    claimerContract,
                                    (0,viem__WEBPACK_IMPORTED_MODULE_22__/* .parseUnits */ .v)(String(amount), 18)
                                ]
                            }))
                        ];
                    case 4:
                        resp = _state.sent();
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            9
                        ]);
                        return [
                            4,
                            (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_19__/* .waitForTransaction */ .Mn)({
                                hash: resp.hash
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 7:
                        e = _state.sent();
                        return [
                            4,
                            (0,_utils_validate__WEBPACK_IMPORTED_MODULE_13__/* .isSkipError */ .D0)(e)
                        ];
                    case 8:
                        if (!_state.sent()) {
                            throw e;
                        }
                        return [
                            3,
                            9
                        ];
                    case 9:
                        console.log("form", form);
                        validatorId = parseFormValidatorId(form);
                        console.log("validatorId", validatorId);
                        return [
                            4,
                            (0,_services_network_claimer__WEBPACK_IMPORTED_MODULE_3__/* .requestMintClaimerSignature */ .qE)({
                                walletAddress: address,
                                validatorTokenId: validatorId,
                                lieutenantAddr: lieutenantAddress || "0x0000000000000000000000000000000000000000"
                            })
                        ];
                    case 10:
                        result = _state.sent();
                        setNftMeta((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, result.message), {
                            validator: validatorId
                        }));
                        return [
                            4,
                            mintClaimerByContract({
                                args: [
                                    address,
                                    parseInt(validatorId || "0"),
                                    parseInt(result.message.score),
                                    lieutenantAddress || "0x0000000000000000000000000000000000000000",
                                    parseInt(result.message.role),
                                    result.signedMessage
                                ]
                            })
                        ];
                    case 11:
                        res = _state.sent();
                        _state.label = 12;
                    case 12:
                        _state.trys.push([
                            12,
                            14,
                            ,
                            16
                        ]);
                        return [
                            4,
                            (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_19__/* .waitForTransaction */ .Mn)(res)
                        ];
                    case 13:
                        transReceipt = _state.sent();
                        if (transReceipt.status === "reverted") {
                            throw new Error("Mint fail");
                        }
                        return [
                            3,
                            16
                        ];
                    case 14:
                        e1 = _state.sent();
                        return [
                            4,
                            (0,_utils_validate__WEBPACK_IMPORTED_MODULE_13__/* .isSkipError */ .D0)(e1)
                        ];
                    case 15:
                        if (!_state.sent()) {
                            throw e1;
                        }
                        return [
                            3,
                            16
                        ];
                    case 16:
                        mixpanel_browser__WEBPACK_IMPORTED_MODULE_12___default().track("claimer_minted", {
                            walletAddress: address,
                            validatorTokenId: validatorId,
                            lieutenantAddr: lieutenantAddress || "0x0000000000000000000000000000000000000000",
                            mintType: "contract"
                        });
                        _stores__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_5__/* .actions.mint.setHistory */ .Nw.mint.setHistory({
                            history: null,
                            type: "claimer"
                        }));
                        return [
                            2,
                            true
                        ];
                    case 17:
                        setMinting(false);
                        return [
                            7
                        ];
                    case 18:
                        return [
                            2
                        ];
                }
            });
        });
        return function(paymentType, amount) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mintClaimerByContract,
        switchNetworkAsync,
        fetchTransaction,
        chain,
        address,
        _config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK,
        isLogin,
        form,
        lieutenantAddress, 
    ]);
    var contractMint = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
        var validatorId, result, res, transReceipt, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setMinting(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        11,
                        12
                    ]);
                    if (!isLogin) {
                        login();
                        return [
                            2,
                            false
                        ];
                    }
                    if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== _config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK)) return [
                        3,
                        3
                    ];
                    // @ts-ignore
                    return [
                        4,
                        switchNetworkAsync(_config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    console.log("form", form);
                    validatorId = parseFormValidatorId(form);
                    console.log("validatorId", validatorId);
                    return [
                        4,
                        (0,_services_network_claimer__WEBPACK_IMPORTED_MODULE_3__/* .requestMintClaimerSignature */ .qE)({
                            walletAddress: address,
                            validatorTokenId: validatorId,
                            lieutenantAddr: lieutenantAddress || "0x0000000000000000000000000000000000000000"
                        })
                    ];
                case 4:
                    result = _state.sent();
                    setNftMeta((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, result.message), {
                        validator: validatorId
                    }));
                    return [
                        4,
                        mintClaimerByContract({
                            args: [
                                address,
                                parseInt(validatorId || "0"),
                                parseInt(result.message.score),
                                lieutenantAddress || "0x0000000000000000000000000000000000000000",
                                parseInt(result.message.role),
                                result.signedMessage
                            ]
                        })
                    ];
                case 5:
                    res = _state.sent();
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        8,
                        ,
                        10
                    ]);
                    return [
                        4,
                        (0,wagmi_actions__WEBPACK_IMPORTED_MODULE_19__/* .waitForTransaction */ .Mn)(res)
                    ];
                case 7:
                    transReceipt = _state.sent();
                    if (transReceipt.status === "reverted") {
                        throw new Error("Mint fail");
                    }
                    return [
                        3,
                        10
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        4,
                        (0,_utils_validate__WEBPACK_IMPORTED_MODULE_13__/* .isSkipError */ .D0)(e)
                    ];
                case 9:
                    if (!_state.sent()) {
                        throw e;
                    }
                    return [
                        3,
                        10
                    ];
                case 10:
                    mixpanel_browser__WEBPACK_IMPORTED_MODULE_12___default().track("claimer_minted", {
                        walletAddress: address,
                        validatorTokenId: validatorId,
                        lieutenantAddr: lieutenantAddress || "0x0000000000000000000000000000000000000000",
                        mintType: "contract"
                    });
                    _stores__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_5__/* .actions.mint.setHistory */ .Nw.mint.setHistory({
                        history: null,
                        type: "claimer"
                    }));
                    return [
                        2,
                        true
                    ];
                case 11:
                    setMinting(false);
                    return [
                        7
                    ];
                case 12:
                    return [
                        2
                    ];
            }
        });
    }), [
        mintClaimerByContract,
        switchNetworkAsync,
        fetchTransaction,
        chain,
        address,
        _config_config__WEBPACK_IMPORTED_MODULE_7__/* .zksyncChainId */ .LK,
        isLogin,
        form,
        lieutenantAddress, 
    ]);
    var karatRecoverMint = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
        var validatorId, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!isLogin) {
                        login();
                        return [
                            2,
                            false
                        ];
                    }
                    setMinting(true);
                    validatorId = parseFormValidatorId(form);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        4,
                        5
                    ]);
                    if (!form.recover_tx) {
                        throw new Error("miss transaction hash");
                    }
                    mixpanel_browser__WEBPACK_IMPORTED_MODULE_12___default().track("recover_mint_claimer", {
                        walletAddress: address,
                        validatorTokenId: validatorId,
                        lieutenantAddr: lieutenantAddress || "0x0000000000000000000000000000000000000000",
                        depositChainId: form.recover_chain || 1,
                        depositTransactionHash: form.recover_tx
                    });
                    return [
                        4,
                        (0,_services_network_claimer__WEBPACK_IMPORTED_MODULE_3__/* .mintByClaimer */ .R8)({
                            walletAddress: address,
                            validatorTokenId: validatorId,
                            lieutenantAddr: lieutenantAddress || "0x0000000000000000000000000000000000000000",
                            depositChainId: form.recover_chain || 1,
                            depositTransactionHash: form.recover_tx
                        })
                    ];
                case 2:
                    result = _state.sent();
                    setNftMeta((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, result.message), {
                        validator: validatorId
                    }));
                    setMintId(result.mintId);
                    _stores__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_5__/* .actions.mint.clearHistory */ .Nw.mint.clearHistory({
                        tx: form.recover_tx
                    }));
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            mintResultRef.current.timer = setInterval(function() {
                                console.log("check mint", mintResultRef);
                                if (mintResultRef.current.error) {
                                    clearInterval(mintResultRef.current.timer);
                                    return reject(mintResultRef.current.error.message);
                                }
                                if (mintResultRef.current.success) {
                                    clearInterval(mintResultRef.current.timer);
                                    return resolve(true);
                                }
                            }, 1000);
                        })
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 4:
                    setMinting(false);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    }), [
        karatDeposit,
        chain,
        form,
        address,
        mintHistory,
        mintStatus,
        isLogin,
        lieutenantAddress, 
    ]);
    var karatMint = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
        var history, ref, escrowDepositInfo, chainId, validatorId, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!isLogin) {
                        login();
                        return [
                            2,
                            false
                        ];
                    }
                    if (!(mintHistory && mintStatus === "success")) return [
                        3,
                        1
                    ];
                    history = mintHistory;
                    return [
                        3,
                        5
                    ];
                case 1:
                    escrowDepositInfo = form === null || form === void 0 ? void 0 : form.karat;
                    chainId = (mintHistory === null || mintHistory === void 0 ? void 0 : mintHistory.chainId) || (escrowDepositInfo === null || escrowDepositInfo === void 0 ? void 0 : (ref = escrowDepositInfo.token) === null || ref === void 0 ? void 0 : ref.chainId);
                    if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== chainId)) return [
                        3,
                        3
                    ];
                    // @ts-ignore
                    return [
                        4,
                        switchNetworkAsync(chainId)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        karatDeposit()
                    ];
                case 4:
                    history = _state.sent();
                    _state.label = 5;
                case 5:
                    setMinting(true);
                    return [
                        4,
                        new Promise(function(resolve) {
                            setTimeout(resolve, 3000);
                        })
                    ];
                case 6:
                    _state.sent();
                    validatorId = parseFormValidatorId(form);
                    _state.label = 7;
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    return [
                        4,
                        (0,_services_network_claimer__WEBPACK_IMPORTED_MODULE_3__/* .mintByClaimer */ .R8)({
                            walletAddress: address,
                            validatorTokenId: validatorId,
                            lieutenantAddr: lieutenantAddress || "0x0000000000000000000000000000000000000000",
                            depositChainId: history.chainId,
                            depositTransactionHash: history.transaction
                        })
                    ];
                case 8:
                    result = _state.sent();
                    setNftMeta((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, result.message), {
                        validator: validatorId
                    }));
                    setMintId(result.mintId);
                    _stores__WEBPACK_IMPORTED_MODULE_5__/* ["default"].dispatch */ .ZP.dispatch(_stores__WEBPACK_IMPORTED_MODULE_5__/* .actions.mint.setHistory */ .Nw.mint.setHistory({
                        history: null,
                        type: "claimer"
                    }));
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            mintResultRef.current.timer = setInterval(function() {
                                console.log("check mint", mintResultRef);
                                if (mintResultRef.current.error) {
                                    clearInterval(mintResultRef.current.timer);
                                    return reject(mintResultRef.current.error.message);
                                }
                                if (mintResultRef.current.success) {
                                    clearInterval(mintResultRef.current.timer);
                                    return resolve(true);
                                }
                            }, 1000);
                        })
                    ];
                case 9:
                    _state.sent();
                    mixpanel_browser__WEBPACK_IMPORTED_MODULE_12___default().track("claimer_minted", {
                        walletAddress: address,
                        validatorTokenId: validatorId,
                        lieutenantAddr: lieutenantAddress || "0x0000000000000000000000000000000000000000",
                        mintType: "one-click",
                        chianId: history === null || history === void 0 ? void 0 : history.chainId
                    });
                    return [
                        2,
                        true
                    ];
                case 10:
                    setMinting(false);
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    }), [
        karatDeposit,
        chain,
        form,
        address,
        mintHistory,
        mintStatus,
        isLogin,
        lieutenantAddress, 
    ]);
    var zkSyncMint = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
        var zksyncDepositInfo, history, chainId;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!isLogin) {
                        login();
                        return [
                            2,
                            false
                        ];
                    }
                    zksyncDepositInfo = form === null || form === void 0 ? void 0 : form.zksync;
                    if (!(mintHistory && mintStatus === "success")) return [
                        3,
                        1
                    ];
                    history = mintHistory;
                    return [
                        3,
                        5
                    ];
                case 1:
                    chainId = String((mintHistory === null || mintHistory === void 0 ? void 0 : mintHistory.chainId) || (zksyncDepositInfo === null || zksyncDepositInfo === void 0 ? void 0 : zksyncDepositInfo.chain));
                    if (!((chain === null || chain === void 0 ? void 0 : chain.id) !== parseInt(chainId))) return [
                        3,
                        3
                    ];
                    // @ts-ignore
                    return [
                        4,
                        switchNetworkAsync(parseInt(chainId))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        zkSyncDeposit()
                    ];
                case 4:
                    history = _state.sent();
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        ,
                        8,
                        9
                    ]);
                    setMinting(true);
                    return [
                        4,
                        new Promise(function(resolve) {
                            setTimeout(resolve, 3000);
                        })
                    ];
                case 6:
                    _state.sent();
                    return [
                        4,
                        contractMint()
                    ];
                case 7:
                    _state.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    setMinting(false);
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        true
                    ];
            }
        });
    }), [
        zkSyncDeposit,
        contractMint,
        form,
        switchNetworkAsync,
        mintHistory,
        mintStatus,
        isLogin, 
    ]);
    var mintBtnText = "Deposit & Mint";
    if (mintHistory && mintStatus === "success") {
        mintBtnText = "Mint";
    }
    return {
        depositSuccess: depositSuccess,
        depositing: depositing,
        history: mintHistory,
        minting: minting,
        karatMint: karatMint,
        zkSyncMint: zkSyncMint,
        contractMint: contractMint,
        karatRecoverMint: karatRecoverMint,
        claimerContractInfo: claimerContractInfo,
        mintBtnText: mintBtnText,
        defaultDepositCost: 0.02,
        nftMeta: nftMeta,
        isValidLieutenant: isValidLieutenant,
        hasParamLieutenant: hasParamLieutenant,
        contractMintWithPay: contractMintWithPay
    };
}


/***/ }),

/***/ 78338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ cryptoPayments; },
/* harmony export */   "z": function() { return /* binding */ ClaimerPaymentType; }
/* harmony export */ });
/* harmony import */ var _contract__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26720);
/* harmony import */ var _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31407);


var cryptoPayments = {
    zkSyncTestnet: {
        name: "zkSyncTest",
        symbol: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .zkSyncTestnet.nativeCurrency.symbol */ .B$.nativeCurrency.symbol,
        enableOneClick: false,
        chain: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .zkSyncTestnet */ .B$,
        tokenAddress: "0x0000000000000000000000000000000000000000",
        gas: 0.0012,
        mintFee: {
            USDAmount: 2,
            tokenAmount: 0.0012,
            token: {
                address: "0x0000000000000000000000000000000000000000",
                chainId: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .zkSyncTestnet.id */ .B$.id,
                symbol: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .zkSyncTestnet.nativeCurrency.symbol */ .B$.nativeCurrency.symbol
            }
        }
    },
    zkSyncKAT: {
        name: "Karat Token",
        symbol: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .zkSync.nativeCurrency.symbol */ .jM.nativeCurrency.symbol,
        enableOneClick: false,
        chain: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .zkSync */ .jM,
        tokenAddress: "0x0000000000000000000000000000000000000000",
        gas: 0.0012,
        mintFee: {
            USDAmount: 2,
            tokenAmount: parseFloat("500"),
            token: {
                address: _contract__WEBPACK_IMPORTED_MODULE_0__/* .KATContractInfo.address */ .Fr.address,
                chainId: _contract__WEBPACK_IMPORTED_MODULE_0__/* .KATContractInfo.chainId */ .Fr.chainId,
                symbol: "KAT"
            }
        }
    },
    zkSync: {
        name: "zkSync",
        symbol: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .zkSync.nativeCurrency.symbol */ .jM.nativeCurrency.symbol,
        enableOneClick: false,
        chain: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .zkSync */ .jM,
        tokenAddress: "0x0000000000000000000000000000000000000000",
        gas: 0.0012,
        mintFee: {
            USDAmount: 2,
            tokenAmount: parseFloat("0.0033"),
            token: {
                address: "0x0000000000000000000000000000000000000000",
                chainId: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .zkSync.id */ .jM.id,
                symbol: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .zkSync.nativeCurrency.symbol */ .jM.nativeCurrency.symbol
            }
        }
    },
    goerli: {
        name: "Goerli",
        symbol: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .goerli.nativeCurrency.symbol */ .ws.nativeCurrency.symbol,
        enableOneClick: true,
        chain: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .goerli */ .ws,
        tokenAddress: "0x0000000000000000000000000000000000000000",
        gas: 0.0012,
        mintFee: {
            USDAmount: 2
        }
    },
    ethereum: {
        name: "Ethereum",
        symbol: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .mainnet.nativeCurrency.symbol */ .RJ.nativeCurrency.symbol,
        enableOneClick: true,
        chain: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .mainnet */ .RJ,
        tokenAddress: "0x0000000000000000000000000000000000000000",
        gas: 0.0012,
        mintFee: {
            USDAmount: 2
        }
    },
    bsc: {
        name: "BSC",
        symbol: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .bsc.nativeCurrency.symbol */ .eG.nativeCurrency.symbol,
        enableOneClick: true,
        chain: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .bsc */ .eG,
        tokenAddress: "0x0000000000000000000000000000000000000000",
        gas: 0.0092,
        mintFee: {
            USDAmount: 2
        }
    },
    polygon: {
        name: "Polygon",
        symbol: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .polygon.nativeCurrency.symbol */ .yu.nativeCurrency.symbol,
        enableOneClick: true,
        chain: _wagmi_chains__WEBPACK_IMPORTED_MODULE_1__/* .polygon */ .yu,
        tokenAddress: "0x0000000000000000000000000000000000001010",
        gas: 3.6324,
        mintFee: {
            USDAmount: 2
        }
    }
};
var ClaimerPaymentType;
(function(ClaimerPaymentType) {
    ClaimerPaymentType[ClaimerPaymentType["KAT"] = 0] = "KAT";
    ClaimerPaymentType[ClaimerPaymentType["ETH"] = 1] = "ETH";
})(ClaimerPaymentType || (ClaimerPaymentType = {}));


/***/ })

}]);